import { apiRequest } from './client'
import type { AuthMe } from './types'

export const authApi = {
  setupStatus: () => apiRequest<{ data: { setupRequired: boolean } }>('/auth/setup-status'),

  setup: (input: { username: string; displayName: string; email?: string; password: string }) =>
    apiRequest<{ data: { id: string; username: string } }>('/auth/setup', { method: 'POST', body: input }),

  login: (input: { username: string; password: string }) =>
    apiRequest<{ data: { id: string; username: string } }>('/auth/login', { method: 'POST', body: input }),

  logout: () => apiRequest<{ data: { success: boolean } }>('/auth/logout', { method: 'POST' }),

  me: () => apiRequest<{ data: AuthMe }>('/auth/me'),

  changePassword: (input: { currentPassword: string; newPassword: string }) =>
    apiRequest<{ data: { success: boolean } }>('/auth/change-password', { method: 'POST', body: input }),
}
